var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2677_4601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2973 2.11504C11.6888 1.72353 11.8845 1.52777 12.1014 1.43416C12.4138 1.29929 12.7681 1.29929 13.0805 1.43416C13.2974 1.52777 13.4931 1.72353 13.8846 2.11504C14.2761 2.50655 14.4719 2.70231 14.5655 2.91917C14.7004 3.23161 14.7004 3.58584 14.5655 3.89827C14.4719 4.11513 14.2761 4.31089 13.8846 4.7024L10.5369 8.05013C9.71211 8.87492 9.29972 9.28732 8.7832 9.53167C8.26668 9.77602 7.68629 9.83329 6.52549 9.94782L6 9.99968L6.05185 9.47419C6.16639 8.31339 6.22366 7.73299 6.46801 7.21647C6.71236 6.69996 7.12475 6.28756 7.94955 5.46277L11.2973 2.11504Z",
    stroke: "#798692",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 10H2.50004C1.85571 10 1.33337 10.5223 1.33337 11.1667C1.33337 11.811 1.85571 12.3333 2.50004 12.3333H8.83337C9.47771 12.3333 10 12.8557 10 13.5C10 14.1443 9.47771 14.6667 8.83337 14.6667H7.33337",
    stroke: "#798692",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2677_4601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1747402b2b4a12a37d7e56e454cb5e34.svg";
export { ForwardRef as ReactComponent };